/**
 * The feedback enum is used to track the user's feedback on a given feature
 */
export const enum Feedback {
  GOOD = "good",
  BAD = "bad",
}
